import { getInstanceType } from '@/api/instances-api'
import getTranslation from '@/i18n/getTranslation'

export default {
  data() {
    return {
      productLineList: [{ value: '', label: getTranslation('全部') }],
      productLineListNoAll: []
    }
  },
  created() {
    this.fetchInstanceType()
  },
  methods: {
    async fetchInstanceType() {
      const { result } = await getInstanceType()
      this.productResourceList = result.products
      result.products &&
        result.products.forEach(ele => {
          this.productLineList.push({
            value: ele.reservedInstanceType,
            label: ele.typeName
          })
        })
      this.productLineListNoAll = this.productLineList.slice(1)
    }
  }
}
